import AdminLogin from '@pages/admin/auth/login'
import About from '@pages/user/aboutus/About'
import PrivacyPolicy from '@pages/user/aboutus/PrivacyPolicy'
import RefundPolicy from '@pages/user/aboutus/RefundPolicy'
import TermsCondition from '@pages/user/aboutus/TermsCondition'
import BookDesc from '@pages/user/allPages/BookDesc'
import LoginPage from '@pages/user/auth/login'
import OtpPage from '@pages/user/auth/otp'
import PhonePage from '@pages/user/auth/phone'
import RegisterPage from '@pages/user/auth/register'
import ResetPassword from '@pages/user/auth/resetPassword'
import OtpInutResetPassword from '@pages/user/auth/resetPassword/OtpInutResetPassword'
import PhoneInputResetPassword from '@pages/user/auth/resetPassword/PhoneInputResetPassword'
import HomePage from '@pages/user/home/HomePage'

const publicRoutes = [
  {
    Component: HomePage,
    exact: true,
    index: true,
  },

  {
    Component: AdminLogin,
    exact: true,
    path: 'admin-login',
  },
  {
    Component: PhonePage,
    path: 'phone-input',
  },
  {
    Component: OtpPage,
    path: 'otp-verify',
  },
  {
    Component: RegisterPage,
    path: 'register',
  },
  {
    Component: LoginPage,
    path: 'login',
  },
  {
    Component: PhoneInputResetPassword,
    path: 'phone-input-reset-password',
  },
  {
    Component: OtpInutResetPassword,
    path: 'otp-verify-reset-password',
  },
  {
    Component: ResetPassword,
    path: 'reset-password',
  },
  {
    Component: BookDesc,
    path: ':name/:id',
  },
  {
    Component: About,
    path: 'about-us',
  },
  {
    Component: PrivacyPolicy,
    path: 'privacy-policy',
  },
  {
    Component: TermsCondition,
    path: 'terms-and-condition',
  },
  {
    Component: RefundPolicy,
    path: 'refund-policy',
  },
]
export default publicRoutes
